export default __webpack_public_path__ + "static/media/1494.10ebbda9.gif";